import '@/assets/css/payment-function.scss';
import { mapState } from "vuex";

// Extend
import basePaymentService from '@/scripts/payment/basePaymentService';

// Component
import TransactionRechargeHistory from "@/views/Payment/TransactionRechargeHistory.vue";
import TransactionCouponHistory from "@/views/Payment/TransactionCouponHistory.vue";
import InvoiceTransaction from "@/views/component/Payment/InvoiceTransaction.vue";
import ExportInvoice from "@/views/component/Payment/ExportInvoice.vue";

export default {

    components: {
        TransactionRechargeHistory,
        TransactionCouponHistory,
        InvoiceTransaction,
        ExportInvoice,
    },

    extends: basePaymentService,

    data() {
        return {
            isShowDetails: false,
            isShowExport: false,
            currentTarget: null,
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.auth.user,
        }),
    },

    created() {

    },

    mounted() {
        setTimeout(() => {
            this.percentage = (this.userInfo.recharged / 1500) * 100;
        }, 1000);
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        // Show details transaction
        showDetailsTransaction(element) {
            this.currentTarget = element;
            this.isShowDetails = true;
        },

        // Show details transaction
        showExportInvoice(element) {
            this.currentTarget = element;
            this.isShowExport = true;
        },
    }
}